module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Dishes-480adc04afaf53fa789a1aac7ef6abb3.svg";